<template>
  <el-tabs v-model="tabPaneVal" type="border-card" @tab-click="handleClick">
    <el-tab-pane label="托运人资料" name="ShipmentEdit">
      <ShipmentEdit
        v-if="isShipmentEditShow"
        ref="ShipmentEditRef"
        :parent-data="parentData"
      />
    </el-tab-pane>
    <el-tab-pane
      v-if="!ctmsShow && isTabShow"
      label="开票信息管理"
      name="InvoiceMessage"
    >
      <InvoiceMessage
        v-if="isInvoiceMessageShow"
        ref="InvoiceMessageRef"
        :parent-data="parentData"
      />
    </el-tab-pane>
    <el-tab-pane
      v-if="!ctmsShow && isTabShow"
      label="地址管理"
      name="CommonRouteInfo"
    >
      <CommonRouteInfo
        v-if="isCommonRouteInfoShow"
        ref="CommonRouteInfoRef"
        :parent-data="parentData"
      />
    </el-tab-pane>
    <el-tab-pane
      v-if="!ctmsShow && isTabShow"
      label="承运分组"
      name="VehicleTeam"
    >
      <VehicleTeam
        v-if="isVehicleTeamShow"
        ref="VehicleTeamRef"
        :parent-data="parentData"
      />
    </el-tab-pane>
    <el-tab-pane
      v-if="!ctmsShow && isTabShow"
      label="合同管理"
      name="ShipmentContract"
    >
      <ShipmentContract
        v-if="isShipmentContractShow"
        ref="ShipmentContractRef"
        :parent-data="parentData"
      />
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import ShipmentEdit from "./components/shipmentEdit.vue";
import InvoiceMessage from "./components/invoiceMessage/invoiceMessageList.vue";
import CommonRouteInfo from "./components/commonRouteInfo/commonRouteInfoList.vue";
import VehicleTeam from "./components/vehicleTeam/vehicleTeamList.vue";
import ShipmentContract from "./components/shipmentContract/shipmentContractList.vue";
import { getListDict, getShipperList, getGoodsTypeDict } from "@/api/shipment";
import { getRole } from "@/utils/getRole";
export default {
  name: "SelfShipmentForm",
  components: {
    ShipmentEdit,
    InvoiceMessage,
    CommonRouteInfo,
    VehicleTeam,
    ShipmentContract
  },
  data() {
    return {
      parentData: {
        hideCheckbox: true,
        areaOptions: this.$store.state.components.areaOptions,
        receiverUserCodeOptions: [],
        typeOptions: [],
        vehicleDictList: [],
        bankOptions: []
      },
      tabPaneVal: "ShipmentEdit",
      isShipmentEditShow: true,
      isInvoiceMessageShow: false,
      isCommonRouteInfoShow: false,
      isVehicleTeamShow: false,
      isPriceSystemShow: false,
      isCustomerManageShow: false,
      isLineManagementShow: false,
      ctmsShow: false,
      isShipmentContractShow: false,
      isTabShow: false
    };
  },
  created() {
    this.ctmsShow = getRole();
    //console.log('getRole',getRole());
    //console.log('this.ctmsShow',this.ctmsShow );
    const to = this.$route.query.to;
    if (to) {
      this[`is${this.tabPaneVal}Show`] = false;
      this.tabPaneVal = to;
      this[`is${to}Show`] = true;
    }
    // 收票人选项
    getShipperList({ staffTypes: "0,4,6" }).then(response => {
      this.parentData.receiverUserCodeOptions = response.data.records;
    });
    // 货物类型字典
    getGoodsTypeDict({ parentCode: "goodsBigType" }).then(response => {
      this.parentData.goodsTypeList = response.data.records;
    });
    // 开票方式、车型、开户银行 数据字典
    getListDict({ types: "vehicleClassification, bank" }).then(response => {
      this.parentData.vehicleDictList = response.data.filter(
        item => item.type === "vehicleClassification"
      )[0]["dictList"];
      this.parentData.bankOptions = response.data.filter(
        item => item.type === "bank"
      )[0]["dictList"];
    });
    const shipment = this.$store.getters.shipment;
    //console.log('shipment--',shipment);
    //console.log('this.$store.getters',this.$store.getters);
    if (shipment && shipment.staffType <= 1) {
      this.isTabShow = true;
    }
  },
  methods: {
    handleClick(tab, event) {
      this[`is${tab.name}Show`] = true;
      this.$nextTick(() => {
        this.$refs[`${tab.name}Ref`].findList();
      });
    }
  }
};
</script>
